import { connect } from 'react-redux';
import { IStateType } from '../../../store/models/root.interface';
import WhatsappTemplatesList, {
    DispatchPropsType,
    MapStateType
} from '../organisms/whatsappTemplatesList';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { closeSideBar } from '../../../store/sidebar';
import { makeSelectInProgress, makeSelectObjectsArray } from '../../../store/Objects';
import { Instances } from '../../../constants';
import { updateSelectedTemplate } from '../../../store/actions/failover.action';

const mapStateToProps = (state: IStateType) => ({
    whatsappTemplatesInProgress: makeSelectInProgress(Instances.whatsappTemplate)(state),
    whatsappTemplateList: makeSelectObjectsArray(Instances.whatsappTemplate)(state),
});

const mapDispatchToProps = {
    onClose: () => closeSideBar(),
    updateTemplateIdInStore: (id: string) => updateSelectedTemplate(id)
};

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(WhatsappTemplatesList));
